var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar',{staticClass:"d-print-none"}),_c('v-main',{staticClass:"px-4 pb-4 grey lighten-4"},[_c('router-view')],1),_c('Footer',{staticClass:"d-print-none"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }